import request from '@/utils/request'

// 查询列表
export function apiScpMrpHorizontalSummaryReservePlanApprovalList (query) {
  return request({
    url: '/scp/scpMrpHorizontalSummary/reservePlanApprovalList',
    method: 'get',
    params: query
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}

// 动态表头
export function apiScpMrpHorizontalDatesDateDisplayList (query) {
  return request({
    url: '/scp/scpMrpHorizontalDates/dateDisplayList',
    method: 'get',
    params: query
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 查询头
export function apiScpMrpHorizontalSummaryReservePlanApprovalHead (billNo) {
  return request({
    url: `/scp/scpMrpHorizontalSummary/reservePlanApprovalHead/${billNo}`,
    method: 'get'
  })
}

// 审批
export function apiKernelFlowExternalBpm (url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  })
}
